import { useMemo, useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import {
  BinDistribution,
  Compositions,
  ConsistencyTrend,
  CostTrend,
  ParametersComparison,
  ParametersTrend,
  SpectralImageComparison,
  StorageDistribution,
} from '../features'
import * as sxStyles from './layout.styles'
import { TTabConfig } from '../utils/consts'

interface INestedTabsPage {
  tabsList: TTabConfig[]
}

const NestedTabsPage = ({ tabsList }: INestedTabsPage) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const currentTab = tabsList[selectedTabIndex]
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setSelectedTabIndex(newValue)
  }

  const renderTabs = useMemo<Record<string, React.ReactNode>>(
    () => ({
      parameters_comparison: <ParametersComparison />,
      parameters_trend: <ParametersTrend />,
      consistency_trend: <ConsistencyTrend />,
      spectral_image_comparison: <SpectralImageComparison />,
      bin_distribution: <BinDistribution />,
      cost_trends: <CostTrend />,
      compositions: <Compositions />,
      storage_distribution: <StorageDistribution />,
    }),
    []
  )
  const content = renderTabs[currentTab?.key] ?? (
    <div>{currentTab?.label} tab</div>
  )

  return (
    <Box sx={sxStyles.nestedTabsBoxWrapper}>
      <Tabs value={selectedTabIndex} onChange={handleChange}>
        {tabsList.map((tab: TTabConfig, index: number) => (
          <Tab
            sx={sxStyles.tabStyle}
            label={tab.label}
            key={tab.key ?? tab.id}
            value={index}
          />
        ))}
      </Tabs>
      <Box sx={sxStyles.dividerBoxStyle} />
      <Box sx={sxStyles.dataAnalysisContentContainer}>{content}</Box>
    </Box>
  )
}
export default NestedTabsPage
